import { FC } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { CheckListFilterSelector } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../../tracking-ids';
import { FilterTraySection } from '../filter-tray-section/filter-tray-section';
import { useContactTypeFilterData } from './use-contact-type-filter-data';

export const ContactTypeFilterTray: FC<{ disabled?: boolean; showClear?: boolean }> = ({
  disabled,
  showClear = true,
}) => {
  const { value: selectedValues, contactTypeOptions, isLoading, onChange } = useContactTypeFilterData();
  const { t } = useTranslation('call-intelligence');

  const isDisabled = disabled || isLoading;
  return (
    <FilterTraySection
      label={t('Contact Type')}
      disableClear={isDisabled}
      showClear={showClear}
      onClear={() => onChange([])}
    >
      <CheckListFilterSelector<CallIntelTypes.ContactTypeFilterEnum>
        label={t('Contact Type')}
        onChange={onChange}
        options={contactTypeOptions}
        showLabel={false}
        trackingIdBase={trackingIds.callIntel.contactTypesFilter}
        value={selectedValues}
        disabled={isDisabled}
      />
    </FilterTraySection>
  );
};
